import React from 'react'
import CustomersContext from './../context/CustomerContext'
import PropTypes from 'prop-types'

function CustomersProvider(props) {
    const {getCustomers} = props

    return (
        <CustomersContext.Provider
            value={{
                getCustomers,
            }}
        >
            {props.children}
        </CustomersContext.Provider>
    )
}

CustomersProvider.propTypes = {
    getCustomers: PropTypes.func.isRequired
}

export default CustomersProvider
